import * as React from 'react';
import { Snackbar, Alert, AlertColor, Typography, useTheme, styled } from '@mui/material';

export interface SnackbarCustomProps {
  open: boolean;
  message: string | null;
  severity: AlertColor;
  onClose: () => void;
  anchorOrigin?: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
  autoHideDuration?: number;
}

const AlertWrapper = styled(Alert)(({ theme }) => ({
  '& div:last-of-type': {
    paddingLeft: theme.spacing(1),
  },
}));

// to color the closing X icon
const AlertWrapperSuccess = styled(AlertWrapper)(({ theme }) => ({
  '& svg': {
    color: theme.palette.success.main,
  },
}));

// to color the closing X icon
const AlertWrapperError = styled(AlertWrapper)(({ theme }) => ({
  '& svg': {
    color: theme.palette.error.main,
  },
}));

const SnackBarCustom: React.FC<SnackbarCustomProps> = ({
  open,
  message = '',
  severity,
  onClose,
  anchorOrigin = { vertical: 'top', horizontal: 'center' },
  autoHideDuration = 3000,
}) => {
  const theme = useTheme();
  const messageContent = (
    <Typography variant="body1" style={{ color: theme.palette[severity].main }}>
      {message}
    </Typography>
  );

  // to color the closing X icon
  const alertContent =
    severity === 'success' ? (
      <AlertWrapperSuccess onClose={() => onClose()} severity={severity} data-testid="snackbar-success">
        {messageContent}
      </AlertWrapperSuccess>
    ) : severity === 'error' ? (
      <AlertWrapperError onClose={() => onClose()} severity={severity} data-testid="snackbar-fail">
        {messageContent}
      </AlertWrapperError>
    ) : (
      <AlertWrapper onClose={() => onClose()} severity={severity}>
        {messageContent}
      </AlertWrapper>
    );

  return (
    <Snackbar open={open} anchorOrigin={anchorOrigin} autoHideDuration={autoHideDuration} onClose={() => onClose()}>
      {alertContent}
    </Snackbar>
  );
};

export default SnackBarCustom;
